import Vue from 'vue'
import TippyComponent from '@/components/vue-tippy/VueTippy'

Vue.component('Tippy', TippyComponent)
